var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2812 13.8438C16.5625 14.1562 16.5625 14.625 16.25 14.9062L15.375 15.7812C15.0938 16.0938 14.625 16.0938 14.3125 15.7812L11.2188 12.6875C11.0625 12.5312 11 12.3438 11 12.1562V11.625C9.875 12.5 8.5 13 7 13C3.40625 13 0.5 10.0938 0.5 6.5C0.5 2.9375 3.40625 0 7 0C10.5625 0 13.5 2.9375 13.5 6.5C13.5 8.03125 12.9688 9.40625 12.125 10.5H12.625C12.8125 10.5 13 10.5938 13.1562 10.7188L16.2812 13.8438ZM7 10.5C9.1875 10.5 11 8.71875 11 6.5C11 4.3125 9.1875 2.5 7 2.5C4.78125 2.5 3 4.3125 3 6.5C3 8.71875 4.78125 10.5 7 10.5Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/searchIcon.d5013d2dee075020382354f78a9a4f8c.svg";
export { ForwardRef as ReactComponent };